"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.widgetPack = exports.widget = exports.widgetMap = void 0;
const redux_1 = require("redux");
const action_constants_1 = require("../../../../../shared/store/action_constants");
const action_constants_2 = require("../../../../../shared/store/action_constants");
const index_1 = require("../index");
const immer_1 = __importDefault(require("immer"));
const widgetMap = (state = {}, action) => {
    if (action.type === action_constants_2.RESET_WIDGET) {
        const newState = Object.assign({}, state);
        for (const id of action.payload) {
            delete newState[id];
        }
        return newState;
    }
    if (!action.widgetId) {
        return state;
    }
    return Object.assign(Object.assign({}, state), { [action.widgetId]: (0, exports.widgetPack)(state[action.widgetId], action) });
};
exports.widgetMap = widgetMap;
const widget = (state, action) => {
    if (action.type === action_constants_2.RECEIVE_INSTALLATIONS_WIDGET) {
        return action.payload;
    }
    if (!state) {
        return null;
    }
    switch (action.type) {
        case action_constants_1.WIDGET_JOT_ACTION:
            return (0, immer_1.default)(state, draft => {
                (0, index_1.JOTApply)(draft, action);
                return draft;
            });
        case action_constants_1.WIDGET_UPDATE_REVISION:
            return Object.assign(Object.assign({}, state), { revision: action.payload });
        default: {
            return state;
        }
    }
};
exports.widget = widget;
// TODO： finish more here
exports.widgetPack = (0, redux_1.combineReducers)({
    loading: (state = false, _action) => {
        return state;
    },
    syncing: (state = false, _action) => {
        return state;
    },
    connected: (state = false, _action) => {
        return state;
    },
    widget: exports.widget,
});
//# sourceMappingURL=widget.js.map